import React from 'react'

const SvgIcon = ({ slug }) => (
    <span className={`svg-icon svg-icon--${slug}`}>
        <svg className="svg-icon__symbol">
            <use xlinkHref={`#icon-${slug}`} />
        </svg>
    </span>
)

export default SvgIcon



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/components/SvgIcon.jsx